var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppCenterNoResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    fill: "#DFE2EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3868 33.0751C27.4901 31.5587 27.109 29.7708 27.3052 28.0002C27.5013 26.2296 28.2632 24.5799 29.4677 23.3176C30.1689 22.5829 31.0021 22.0001 31.9193 21.6024C32.8365 21.2047 33.8198 21 34.8129 21C35.806 21 36.7893 21.2047 37.7065 21.6024C38.6238 22.0001 39.4569 22.5829 40.1581 23.3176L51.7775 35.4395C53.1904 36.9268 53.9833 38.9373 53.9833 41.0328C53.9833 43.1283 53.1904 45.1389 51.7775 46.6262C50.3539 48.1023 48.4295 48.9307 46.4238 48.9307C44.4181 48.9307 42.4937 48.1023 41.0701 46.6262L37.3672 42.4888",
    stroke: "#A8B2C8",
    strokeWidth: 3.79213,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7455 51.1602C56.5705 52.6681 56.8983 54.4174 56.6786 56.139C56.4589 57.8605 55.7038 59.459 54.5295 60.6883C53.1088 62.1634 51.1872 62.9913 49.1843 62.9913C47.1813 62.9913 45.2597 62.1634 43.839 60.6883L32.2197 48.5488C30.8078 47.0645 30.0154 45.0569 30.0154 42.9643C30.0154 40.8717 30.8078 38.864 32.2197 37.3797C33.6433 35.9036 35.5677 35.0752 37.5734 35.0752C39.5791 35.0752 41.5035 35.9036 42.927 37.3797L46.2159 41.2226",
    stroke: "#A8B2C8",
    strokeWidth: 3.79213,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppCenterNoResults);
export default __webpack_public_path__ + "static/media/app_center_no_results.ad11d1814624e5128ba7f982e2730149.svg";
export { ForwardRef as ReactComponent };